import { render } from "./TermsNoticePopup.vue?vue&type=template&id=9b42509c"
import script from "./TermsNoticePopup.vue?vue&type=script&lang=js"
export * from "./TermsNoticePopup.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TermsNoticePopup.vue?vue&type=style&index=0&id=9b42509c&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__